import { CompanyAttributes } from '@albatrosdeveloper/ave-models-package';
import BusinessPartnerAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity';
import { CommonModule, DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { MatSlideToggle, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatRowDef, MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgSelectComponent } from '@ng-select/ng-select';
import { CustomMatPaginatorIntl } from 'app/mock-api/common/customPaginatorIntl';
import { getCode } from "app/utils/method";
import { environment } from "environments/environment.prod";
import { RejectionTypeService } from './rejection-type.service';
import { ICreateRejectionType } from './interfaces/create-rejection-type.interface';
import ReasonRejectionTypeAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/masters/reason-rejection-types/types-reason-rejection.entity';
import { CompanyService } from '../../configuration/company/company.service.service';
import { Subscription } from 'rxjs';
import { SearchService } from 'app/layout/common/search-page/search-page.service';
import { FilterComponent } from 'app/common/components/filter/filter.component';
import { StatusFiltersComponent } from '../../filters/status-filters/status-filters.component';
import { ConfigurationFiltersComponent } from '../../filters/configuration-filters/configuration-filters.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { StatusEnum } from '@albatrosdeveloper/ave-models-package/lib/enums';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";

@Component({
  selector: 'app-rejection-type',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatIconModule,
    MatRowDef,
    MatSidenavContainer,
    FormsModule,
    NgSelectComponent,
    MatTabsModule,
    CommonModule,
    MatSlideToggleModule,
    FilterComponent,
    StatusFiltersComponent,
    ConfigurationFiltersComponent,
    HoverMenuDirective
  ],
  templateUrl: './rejection-type.component.html',
  styleUrl: './rejection-type.component.scss',
  providers: [DatePipe,
      { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    ],
})
export class RejectionTypeComponent implements OnDestroy{ 
  getCode = getCode;
  isSync = environment.isSync //sincroniza por lo tanto no debe haber external 
  displayedColumns: string[] = ["name","statusId",
    // "actions"
  ];
  
  dataSource: ReasonRejectionTypeAttributes[] = [];
  companyList: CompanyAttributes[] = [];
  selectedCompanyIds: number[] = [];
  
  // Status filter properties
  selectedStatuses: number[] = [1, 0];
  
  // Company filter form
  companyFilterForm: FormGroup;

  currentCreateRejectionType: ICreateRejectionType = this.initializeCreateRejectionType();
  currentUpdateRejectionType : ReasonRejectionTypeAttributes |undefined;
  currentUpdateBusinessPartner: BusinessPartnerAttributes | undefined;

  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("searchInput") searchInput!: ElementRef;

  searchQuery: string = "";
  totalItems: number = 0;
  pageSize: number = 50;
  pageIndex: number = 0;

  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit:MatDialogRef<any>;
  
  rejectionTypeSaved = false;

  //BUSCADOR
  searchSubscription: Subscription;
  
  constructor(
    private readonly rejectioTypeService: RejectionTypeService,
    private readonly searchService: SearchService,
    private companyService: CompanyService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder
  ) {
    this.companyFilterForm = this.fb.group({
      companyId: ['']
    });
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.setupPaginationAndSorting();
    this.findAllWithCount();
    this.fetchAllCompanies();
  }

  private initializeCreateRejectionType(): ICreateRejectionType {
    return {
      code: '',
      name: '',
      companyId: '',
    };
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }

  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          this.paginator.pageIndex = 0;
          this.findAllWithCount();
        }
      });
  }

  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }

  findAllWithCount(): void {
    const pageIndex = this.paginator.pageIndex + 1;
    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" =
      this.sort.direction === "asc" ? "ASC" : "DESC";

    this.rejectioTypeService
      .findAllWithCount({
        currentPage: pageIndex,
        limitPerPage: this.pageSize,
        search: this.searchQuery,
        sort: sortField,
        sortDirection: sortDirection,
        status: this.selectedStatuses
      },
    this.selectedCompanyIds)
      .subscribe((data) => {
        this.dataSource = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.paginator.length = this.totalItems;
      });
  }

  private getSortField(): keyof ReasonRejectionTypeAttributes {
      const validSortFields: (keyof ReasonRejectionTypeAttributes)[] = [
        "name",
        "statusId",
      ];
      return validSortFields.includes(
        this.sort.active as keyof ReasonRejectionTypeAttributes
      )
        ? (this.sort.active as keyof ReasonRejectionTypeAttributes)
        : "name";
    }

  private fetchAllCompanies(): void {
    this.companyService.findToComboBox().subscribe({
      next: (res) => {
        this.companyList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener compañias.","Cerrar",{ duration: 5000});
      },
    });
  }

  openCreateModal(): void {
    this.currentCreateRejectionType = this.initializeCreateRejectionType();
    this.cdr.detectChanges();
    this.dialogRefAdd = this.dialog.open(this.addModal, { panelClass: "form-modal",  disableClose: true })
    this.dialogRefAdd.afterClosed().subscribe((result) => { result });
  }
  
  createRejectionType(): void {
    this.rejectioTypeService.create(this.currentCreateRejectionType).subscribe({
      next: () => {
        this.snackBar.open("Registro creado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.findAllWithCount();
        this.dialogRefAdd.close(true);
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al crear el registro",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  openEditModal(rejectionType: ReasonRejectionTypeAttributes): void {
    this.currentUpdateRejectionType = { ...rejectionType };
    this.dialogRefEdit = this.dialog.open(this.editModal, { panelClass: "form-modal", disableClose:true })
    // this.dialogRefEdit.afterClosed().subscribe((result) => result && this.updateRejectionType(rejectionType._id.toString()));
    this.dialogRefEdit.afterClosed().subscribe((result) => { result });
  }

  updateRejectionType(id:string): void{
    if (this.currentUpdateRejectionType) {
          const updatedRejectionType: any = {
            ...this.currentUpdateRejectionType,
            companyId: this.currentUpdateRejectionType.company._id.toString(),
          };
          this.rejectioTypeService.update(id, updatedRejectionType).subscribe({
            next: () => {
              this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
                duration: 3000,
              });
              this.findAllWithCount();
              this.dialogRefEdit.close(true);
            },
            error: (err) => {
              this.snackBar.open(
                err.error.message || "Error al actualizar el registro",
                "Cerrar",
                { duration: 3000 }
              );
            },
          });
        }
  }

  openDeleteDialog(rejectionType: ReasonRejectionTypeAttributes): void {
      this.dialog
      .open(this.deleteDialog, { data: rejectionType, panelClass: "delete-modal", disableClose:true })
      .afterClosed()
      .subscribe((result) => result && this.delete(rejectionType._id.toString()));
  }

  delete(id: string): void {
    this.rejectioTypeService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.snackBar.open("Registro eliminado con éxito", "Cerrar", {
        duration: 3000,
      });
    });
  }

  onStatusChange(event: boolean, rejectionType: any): void {
      const originalStatusId = rejectionType.statusId;
      const updatedStatusId = event ? 1 : 0;
      const updatedRejectionType = { ...rejectionType, statusId: updatedStatusId };
  
      this.rejectioTypeService
        .update(rejectionType._id.toString(), updatedRejectionType)
        .subscribe({
          next: () => {
            this.findAllWithCount();
          },
          error: () => {
            rejectionType.statusId = originalStatusId; // Volver al estado original si falla
            this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
              duration: 3000,
            });
            this.findAllWithCount();
          },
        });
    }

  trackByFn(index: number, item: any): string {
      return item._id.toString();
  }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }

  onCompanySelectionChange(companyIds: string[]): void {
    if (this.currentUpdateBusinessPartner) {
      this.currentUpdateBusinessPartner.companies = companyIds.map(
        (companyId) =>
          this.companyList.find(
            (company) => company._id.toString() === companyId
          )!
      );
    }
  }

  onPageChange(event: PageEvent): void {
      this.pageSize = event.pageSize;
      this.pageIndex = event.pageIndex;
      this.findAllWithCount();
  }


  clearFilters(): void {
    this.selectedStatuses = [];
    this.selectedCompanyIds = [];
    this.companyFilterForm.patchValue({ companyId: '' });
    this.searchQuery = "";
    this.paginator.pageIndex = 0;
    this.findAllWithCount();
  }

  onFilterEvent(): void {
    const companyId = this.companyFilterForm.get('companyId')?.value;
    this.selectedCompanyIds = companyId ? [companyId] : [];
    this.paginator.pageIndex = 0;
    this.findAllWithCount();
  }

  onCleanEvent(): void {
    this.companyFilterForm.patchValue({ companyId: '' });
    this.selectedCompanyIds = [];
    this.paginator.pageIndex = 0;
    this.findAllWithCount();
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }

  applyStatusFilter(): void {
    this.paginator.pageIndex = 0;
    this.findAllWithCount();
  }
}
